<div>
  <h4>Chemical Application Location Information</h4>
</div>
<form id="locationForm" #locationForm="ngForm">
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-10 col-xxl-11">
        <h6>Location Name</h6>
        <input pInputText #locationInput required name="name" [(ngModel)]="location.location" fluid />
      </div>
      <div class="col-12 col-md-2 col-xxl-1 push-contents-to-bottom">
        <p-button type="submit" [disabled]="saving" (click)="saveChemicalApplicationLocation(locationForm)"
          severity="success" label="Save">
        </p-button>
        <p-button type="button" severity="warn" (click)="clear(locationForm);" label="Clear">
        </p-button>
      </div>

      <div class="col-12">
        @if (locationForm.invalid && locationForm.submitted) {
        <div class="alert alert-danger" role="alert">
          There are errors on this page. Please correct the errors and resubmit.
        </div>
        }
      </div>
    </div>
  </div>
</form>
<br>
<p-table showGridlines stripedRows responsiveLayout="stack" [columns]="cols" [value]="locations" [paginator]="true"
  [rows]="30">
  <ng-template pTemplate="header" let-columns>
    <tr>
      @for (col of columns; track col) {
      <th [pSortableColumn]="col.field" [style.width]="col.width">
        {{col.header}}
        @if (col.header != '') {
        <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
          ariaLabelDesc="Activate to sort in descending order"
          ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
        }
      </th>
      }
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-location let-columns="columns" let-rowIndex="rowIndex">
    <tr>
      <td><span class="p-column-title">{{columns[0].header}}</span>{{location.location}}</td>
      <td>
        <p-button type="button" icon="pi pi-pencil" (click)="editChemicalApplicationLocation(location)"
          severity="info">
        </p-button>
        <p-button type="button" icon="pi pi-trash" (click)="deleteChemicalApplicationLocation(location)"
          severity="danger">
        </p-button>
      </td>
    </tr>
  </ng-template>
</p-table>
<br>